import { TireLeadReason, TireLeadReasonLabels } from '@navio/nsdk';

// nsdk keys TireLeadReasonLabels by member name (`WORN_TREAD`), not by the API value (`worn_tread`).
// Keyed by value here so a reason added to the enum fails to compile until it has a label.
export const TIRE_LEAD_REASON_LABELS: Record<TireLeadReason, string> = {
  [TireLeadReason.WORN_TREAD]: TireLeadReasonLabels.WORN_TREAD,
  [TireLeadReason.UNEVEN_WEAR]: TireLeadReasonLabels.UNEVEN_WEAR,
  [TireLeadReason.CRACKS_DRY_ROT]: TireLeadReasonLabels.CRACKS_DRY_ROT,
  [TireLeadReason.SIDEWALL_DAMAGE]: TireLeadReasonLabels.SIDEWALL_DAMAGE,
  [TireLeadReason.PUNCTURE]: TireLeadReasonLabels.PUNCTURE,
  [TireLeadReason.OLD_TIRES]: TireLeadReasonLabels.OLD_TIRES,
  [TireLeadReason.CUSTOMER_WISH]: TireLeadReasonLabels.CUSTOMER_WISH,
  [TireLeadReason.OTHER]: TireLeadReasonLabels.OTHER
};

export const formatTireLeadReasons = (reasons: TireLeadReason[]) =>
  reasons.map((reason) => TIRE_LEAD_REASON_LABELS[reason]).join(', ');
